<template>
  <v-container
    id="reservations"
    tag="section"
  >
    <div>
      <div class="d-flex justify-space-between">
        <h1>
          Reservations
        </h1>
      </div>
      <v-row>
        <v-col class="py-0">
          <div class="button-group">
            <v-btn
              color="secondary"
              @click="toggleUploadCSV"
            >
              Upload CSV
            </v-btn>
            <v-btn
              color="secondary"
              @click="getTemplate"
            >
              Export CSV Template
            </v-btn>
            <v-btn
              v-if="hasReservations"
              color="error"
              fab
              small
              dark
              @click="handleDeleteAll"
            >
              <v-icon>$faTrash</v-icon>
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <reservations-list
        ref="reservationsList"
        :filter-by="'organization_id'"
        @reservation-deleted="saveReservation"
      />
    </div>
    <reservations-upload-modal
      v-if="uploadModal"
      :upload-modal.sync="uploadModal"
      @file-uploaded="fileUploaded"
      @close-upload-modal="toggleUploadCSV"
    />
    <delete-reservations-modal
      :title.sync="deleteType.title"
      :message.sync="deleteType.message"
      :confirmation-button.sync="deleteType.confirmationButton"
      :delete-modal.sync="deleteModal"
      @confirm-deletion="deletionHandler"
      @close-delete-modal="deleteModal = false"
    />
  </v-container>
</template>

<script>
  import { mapGetters } from 'vuex'
  import ReservationsUploadModal from '../../components/reservations/ReservationsUploadModal.vue'
  import DeleteReservationsModal from '@/components/reservations/DeleteReservationsModal.vue'
  import ReservationsList from '../../components/reservations/ReservationsList.vue'

  export default {
    name: 'Reservations',
    components: {
      ReservationsUploadModal,
      ReservationsList,
      DeleteReservationsModal,
    },
    data: () => ({
      uploadModal: false,
      deleteModal: false,
      deleteAllReservationsModal: true,
    }),
    computed: {
      ...mapGetters({
        selectedOrg: 'Permissions/currentSelectedOrg',
        hasReservations: 'Reservations/hasReservations',
      }),
      deleteType () {
        let deleteModalProps = {
          title: 'Delete All Reservations?',
          message: 'Are you sure you want to delete all reservations? This action is irreversible.',
          confirmationButton: 'Delete All',
        }
        if (!this.deleteAllReservationsModal) {
          deleteModalProps = {
            title: `Delete Reservation ${this.reservation.id}?`,
            message: `Are you sure you want to delete reservation ${this.reservation.id}? This action is irreversible.`,
            confirmationButton: 'Delete',
          }
        }
        return deleteModalProps
      },
    },
    methods: {
      toggleUploadCSV () {
        this.uploadModal = !this.uploadModal
      },
      fileUploaded () {
        this.uploadModal = !this.uploadModal
        this.$refs.reservationsList.fetchList()
      },
      getTemplate () {
        if (!this.selectedOrg.id) {
          const messagePayload = { type: 'warning', text: 'Please select organization to continue.' }
          this.$store.dispatch('updateMessages', messagePayload)
          return
        }
        const payload = {
          filter: [
            { key: 'organization_id', operator: '=', value: `${this.selectedOrg.id}` },
          ],
        }
        this.$store.dispatch('Reservations/getCSVTemplate', payload)
      },
      deletionHandler () {
        if (this.deleteAllReservationsModal) {
          this.deleteAllReservations()
          return
        }
        this.deleteReservation()
      },
      handleDeleteAll () {
        this.deleteAllReservationsModal = true
        this.deleteModal = !this.deleteModal
      },
      async deleteAllReservations () {
        await this.$store.dispatch('Reservations/bulkDelete').then(() => {
          this.deleteModal = !this.deleteModal
          this.$refs.reservationsList.fetchList()
        })
      },
      saveReservation (reservation) {
        this.reservation = reservation
        this.deleteAllReservationsModal = false
        this.deleteModal = !this.deleteModal
      },
      async deleteReservation () {
        await this.$store.dispatch('Reservations/deleteReservation', this.reservation).then(() => {
          this.deleteModal = !this.deleteModal
          this.$refs.reservationsList.fetchList()
        })
      },
    },
  }
</script>
